<template>
  <div :class="tabIndex === 0 ? 'customer-detail ofauto' : 'customer-detail'">
    <div class="top-wrap">
      <div class="customer-infowrap">
        <div class="customer-info">
          <div class="middle">
            <div class="customername fs16">{{customerInfo.customerName}}</div>
            <div class="customeraddr fs12">{{customerInfo.provinceName ? (customerInfo.provinceName + (customerInfo.cityName ? customerInfo.cityName : "") + (customerInfo.districtName ? customerInfo.districtName : "") + customerInfo.address) : '---'}}</div>
          </div>
          <div class="right">
            <span class="contact-wrap"><span class="contact primary">{{customerInfo.contact}}</span><a class="phone-a" v-if="customerInfo.mobile" :href="'tel:'+ customerInfo.mobile"><i class="iconfont icon-phone primary"></i></a></span>
          </div>
        </div>
        <div class="customer-bottom"><span class="latesttime">{{'最近跟进时间：' + (customerInfo.serviceFollowUpDate || '---')}}</span><span class="saleman">{{'业务员：' + (customerInfo.staffName || '---')}}</span></div>
      </div>
      <div class="navbar-itemall-wrap balTab">
        <van-tabs type="card" @click="changeTab" color="#1FADF6" v-model="tabIndex">
          <van-tab title="服务信息"></van-tab>
          <van-tab title="跟进"></van-tab>
          <van-tab v-if="isAccountService" title="收票"></van-tab>
        </van-tabs>
      </div>
    </div>
    <div class="app-content content-wrap">
      <div class="serviceinfo-wrap" v-show="tabIndex === 0">
        <div v-if="!showFWXX" class="empty">
          <img src="../../../assets/images/bnodata-white.png" alt="">
          <div class="desc">您无权限查看此信息！</div>
        </div>
        <div v-else>
          <div class="dispatch-wrap">
            <div class="dispatch-item">
              <span class="fs12">客户经理</span>
              <a class="fs16" v-if="dispatchInfo.agentPhone" :href="'tel:'+dispatchInfo.agentPhone"><span>{{dispatchInfo.agent}}</span></a>
              <span class="fs16" v-else>---</span>
            </div>
            <div class="vertical-line"></div>
            <div class="dispatch-item">
              <span class="fs12">记账员</span>
              <a class="fs16" v-if="dispatchInfo.acctPhone" :href="'tel:'+dispatchInfo.acctPhone"><span>{{dispatchInfo.acct}}</span></a>
              <span class="fs16" v-else>---</span>
            </div>
            <div class="vertical-line"></div>
            <div class="dispatch-item">
              <span class="fs12">报税员</span>
              <a class="fs16" v-if="dispatchInfo.taxPhone" :href="'tel:'+dispatchInfo.taxPhone"><span>{{dispatchInfo.tax}}</span></a>
              <span class="fs16" v-else>---</span>
            </div>
          </div>
          <div class="service-wrap">
            <div class="service-title">服务</div>
            <div class="service-content">
              <template v-if="acctService.serviceType != 0">
                <div class="service-acct" v-if="acctService.serviceType == 1 || acctService.serviceType == 3">
                  <div class="acct-top"><span class="servicename">代理记账</span><span v-if="contractInfo">{{contractInfo}}</span></div>
                  <ul class="acct-ul">
                    <li><span class="li-disc"></span><span>记账</span><span class="acct-time">{{(acctService.kjperiod || '---') + ' | ' + (acctService.voucherCount ? (acctService.voucherCount + '张凭证') : '---')}}</span></li>
                    <li><span class="li-disc"></span><span>报税</span><span class="acct-time">{{(acctService.lastTax || '---') + ' | ' + (acctService.taxAmountCount ? ('￥' + acctService.taxAmountCount) : '---')}}</span></li>
                  </ul>
                </div>
                <div class="service-business" v-if="acctService.serviceType == 2 || acctService.serviceType == 3">
                  <div class="business-item" v-for="(item, itemIndex) in busService" :key="itemIndex">
                    <div class="business-top"><span class="servicename">{{item.serviceName}}</span><span>{{'经办人：' + item.staffName}}</span></div>
                    <div class="busnode"><span class="li-disc"></span><span>{{item.currentNodeName}}</span><span class="bus-time">{{( formatStatus(item.status) + (item.manhaurString ? (' | ' +item.manhaurString) : '') )}}</span></div>
                  </div>
                </div>
              </template>
              <template v-else>
                <span>暂无服务</span>
              </template>
            </div>
          </div>
          <div class="taxInfor-wrap">
            <div class="taxInfor-title">税务信息</div>
            <div class="taxInfor-content">
              <div class="taxInfor-row">
                <div class="taxInfor-item">
                  <span class="item-title">纳税性质</span>
                  <span class="item-content" v-if="taxInfor.taxTypeName">{{taxInfor.taxTypeName}}</span>
                  <span v-else>---</span>
                </div>
                <div class="taxInfor-item">
                  <span class="item-title">纳税识别号</span>
                  <span class="item-content" v-if="taxInfor.taxpayerCode">{{taxInfor.taxpayerCode}}</span>
                  <span v-else>---</span>
                </div>
              </div>
              <div class="remark1" v-if="taxInfor.remark1">备注：{{taxInfor.remark1}}</div>
              <div class="taxKind" v-if="taxKind.taxKind && taxKind.taxKind.length>0">
                <div>申报税种</div>
                <ul class="taxKind-ul">
                  <li v-for="(item, itemIndex) in taxKind.taxKind" :key="itemIndex" class="taxKind-li">
                    <span class="taxKind-first">
                      <!-- <span class="li-disc"></span> -->
                      {{item.taxName}}
                    </span><span class="taxKind-last">
                      <span v-if="item.taxTime==1">月报</span>
                      <span v-if="item.taxTime==2">季报</span>
                      <span v-if="item.taxTime==3">半年报</span>
                      <span v-if="item.taxTime==4">年报</span>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="add-btnwrap"><span class="fs16" @click="gotoCheckReport">查看企业财务报表</span></div>
        </div>
      </div>
      <div class="followup-wrap" v-show="tabIndex === 1">
        <!-- 注释新增的查看跟进记录权限，因为缓存问题小程序取不到新增的权限 -->
        <!-- <div v-if="!showFollow" class="empty">
          <img src="../../../assets/images/bnodata-white.png" alt="">
          <div class="desc">您无权限查看此信息！</div>
        </div> -->
        <div v-if="followupData.length === 0" class="empty">
          <img src="../../../assets/images/bnodata-white.png" alt="">
          <div class="desc">暂无跟进记录</div>
        </div>
        <van-steps v-else direction="vertical" :active="-1">
          <van-step v-for="(followup, index) in followupData" :key="index">
            <div style="height:0.8rem;" @click="gotoNewFollowup(0, followup)">
              <div class="followup-name">
                <van-row>
                  <van-col span="18">
                    <div class="text-color ellipsis">{{followup.talktimeStr + '&nbsp;&nbsp;' + followup.followTypeName}}</div>
                  </van-col>
                  <van-col span="6">
                    <div class="text-color text-right">{{followup.staffName}}</div>
                  </van-col>
                </van-row>
              </div>
              <van-row class="followup-msg">
                <van-col span="18">
                  <div class="msg title-color">{{followup.talktext}}</div>
                </van-col>
                <van-col v-if="followup.file && followup.file.length > 0" span="6" class="text-right" style="height: 0.4rem;">
                  <img style="margin-top: 0.17rem;width: 0.28rem;" src="../../../assets/customer/followup-file.png" alt="">
                </van-col>
              </van-row>
            </div>
          </van-step>
        </van-steps>
      </div>
      <div class="followup-wrap" v-show="tabIndex === 2">
        <div v-if="!showSPJL" class="empty">
          <img src="../../../assets/images/bnodata-white.png" alt="">
          <div class="desc">您无权限查看此信息！</div>
        </div>
        <div v-else-if="billRecordData.length === 0" class="empty">
          <img src="../../../assets/images/bnodata-white.png" alt="">
          <div class="desc">暂无收票记录</div>
        </div>
        <van-steps v-else direction="vertical" :active="-1">
          <van-step v-for="(billRecord, index) in billRecordData" :key="index">
            <div style="height:0.8rem;" @click="gotoNewBill(0, billRecord)">
              <div class="followup-name">
                <span class="title-color fs14">{{billRecord.createDate}}</span>
                <span class="common-color fs14 relative float-right">{{billRecord.create}}</span>
              </div>
              <van-row class="followup-msg">
                <van-col span="20">
                  <div class="msg title-color fs16">收取{{billRecord.periods}}发票</div>
                  <div class="billMsg fs12">{{billRecord.totalCount + '&nbsp;'}}张 / {{billRecord.totalAmount > 0 ? billRecord.totalAmount.toFixed(2) : '0'}} 元 / {{'税&nbsp;' + (billRecord.taxTotalAmount > 0 ? billRecord.taxTotalAmount.toFixed(2) : '0' ) + '&nbsp;元'}}</div>
                </van-col>
              </van-row>
            </div>
          </van-step>
        </van-steps>
      </div>
    </div>
    <div v-show="tabIndex === 1" class="add-btnwrap"><span class="fs16" @click="gotoNewFollowup(1)">新增跟进记录</span></div>
    <div v-show="tabIndex === 2 && customerInfo.serviceType != 0 && customerInfo.status != 0 " class="add-btnwrap"><span class="fs16" @click="gotoNewBill(1)">新增收票记录</span></div>
    <div v-show="tabIndex === 2 && (customerInfo.serviceType == 0 || customerInfo.status == 0)" class="add-btnwrap disabled"><span class="fs16">新增收票记录</span></div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {
    Tab,
    Tabs,
    Toast,
    Step,
    Steps,
    Row,
    Col
  } from 'vant';
  Vue.use(Tab)
    .use(Tabs)
    .use(Toast)
    .use(Step)
    .use(Steps)
    .use(Row)
    .use(Col);
  export default {
    name: 'customerDetail',
    data() {
      return {
        companyId: '',
        direction: 'vertical',
        currentStatus: 'process',
        lineStyle: {
          width: 0,
          height: 0
        },
        mainOffset: 0,
        year: 2017,
        month: 1,
        date: '',
        customerInfo: {},
        dispatchInfo: {},
        acctService: { // 代账服务
          // "endYear": 2016,                                 // 合同结束年
          // "startYear": 2016,                               // 合同开始年
          // "startMonth": 12,                                // 合同开始月
          // "endMonth": 12,                                  // 合同结束月
          // "lastTax": "",                                   // 最后一次报税税期
          // "kjperiod": "2013-12-01"                         // 最后一次记账账期
        },
        contractInfo: '',
        // 工商服务信息
        busService: [],
        followupData: [],
        billRecordData: [],
        searchtxt: '',
        inputIsFocus: false,
        calldlgIsShow: false,
        currentPhone: '',
        tabIndex: 0,
        // 税务信息
        taxInfor: {
          taxTypeName: '',
          taxpayerCode: '',
          password: '',
          localTaxPassword: '',
          remark1: ''
        },
        taxKind: {
          stateTax: [
            // {taxName: '111111', taxTime: 1}
          ],
          localTax: [
            // {taxName: '111111', taxTime: 1}
          ]
        },
        errorText: '',
        isAccountService: true,
        isChangingTab: false,
        powerData: this.$store.state.powerData,
        showFWXX: false,
        showSPJL: false,
        showFollow: false,
      }
    },
    methods: {
      formatYM(year, month) {
        return year + '.' + (parseInt(month, 10) < 10 ? '0' : '') + month
      },
      formatDate() {
        if (this.month < 10) {
          this.date = this.year + '-0' + this.month
        } else {
          this.date = this.year + '-' + this.month
        }
      },
      //判断职员权限
      estimatePower(menuName, tabName, operateName) {
        for (let i = 0, lenI = this.powerData.length; i < lenI; i++) {
          //  判断菜单名
          if (menuName == this.powerData[i].name) {
            for (let j = 0, lenJ = this.powerData[i].children.length; j < lenJ; j++) {
              //  判断页签名
              if (tabName == this.powerData[i].children[j].name) {

                if (!operateName) {
                  return this.powerData[i].children[j].status;
                } else {
                  for (let k = 0, lenK = this.powerData[i].children[j].children.length; k < lenK; k++) {
                    //  判断
                    if (operateName == this.powerData[i].children[j].children[k].name) {
                      return this.powerData[i].children[j].children[k].checked;
                    }
                  }
                }
              }
            }
          }
        }
      },
      changeTab(_index) {
        if (_index == 2 && !this.estimatePower("代账服务", "服务管理", "收票记录")) {
          Toast("没有权限：服务管理-收票记录");
          return;
        }
        // if (_index == 1 && !this.estimatePower("客户管理", "客户", "查看跟进记录")) {
        //   Toast("没有权限：客户管理-客户-查看跟进记录");
        //   return;
        // }
        this.isChangingTab = true;
        this.tabIndex = _index
        if (_index == 1) {
          this.$root.$emit('log-record', "60010108");
          this.getFollowup()
        } else if (_index == 2) {
          this.$root.$emit('log-record', "60010109");
          this.getBillRecord()
        } else {
          this.getCustomerInfo();
          this.getCustomerService();
          this.$root.$emit('log-record', "60010107");
        }
      },
      getCustomerInfo() {
        let url = '/fc/small/program/customer?companyId=' + this.companyId;
        this.$http.get(url).then((result) => {
          if (result.data.code == 200) {
            let data = result.data.data
            if (data) {
              this.$store.dispatch("setFromAcctCustomerInfo", data);
              this.customerInfo = data
              data.serviceType == 2 ? this.isAccountService = false : this.isAccountService = true
            }
          }
        })
      },
      getCustomerService() {
        let url = '/fc/small/program/service?companyId=' + this.companyId
        this.$http.get(url).then((result) => {
          if (result.data.code === 200) {
            let data = result.data.data
            if (data) {
              console.log(data.orderInfo)
              this.acctService = data.acctService
              if (this.acctService.startYear) {
                this.contractInfo = this.formatYM(this.acctService.startYear, this.acctService.startMonth) + '-' + this.formatYM(this.acctService.endYear, this.acctService.endMonth)
              }
              this.busService = data.businessService
              let dispatchObj = {}
              data.dispatchInfo.forEach(item => {
                if (item.positionName === '客户经理' && item.acctOrderServiceId == 0) {
                  dispatchObj.agent = item.staffName
                  dispatchObj.agentPhone = item.phone
                } else if (item.positionName === '记账员') {
                  dispatchObj.acct = item.staffName
                  dispatchObj.acctPhone = item.phone
                } else if (item.positionName === '报税员') {
                  dispatchObj.tax = item.staffName
                  dispatchObj.taxPhone = item.phone
                }
              })
              this.dispatchInfo = dispatchObj

              this.taxInfor = data.customer
              this.taxKind = data.taxKind
            }
          }
        })
      },
      getFollowup() {
        let url = '/fc/small/program/followup/small?page=1&limit=200&orderProperty=createDate&orderDirection=desc'
        this.$http.get(url, {
          params: {
            'companyId': this.companyId
          }
        }).then((result) => {
          if (result.data.code === 200) {
            let data = result.data.data
            if (data) {
              this.followupData = data.followUp
            }
          }
        })
      },
      getBillRecord() {
        let url = '/fc/small/program/bill/company?page=1&limit=200&orderProperty=createDate&orderDirection=desc'
        this.$http.get(url, {
          params: {
            'companyId': this.companyId
          }
        }).then((result) => {
          if (result.data.code === 200) {
            let data = result.data.data
            if (data) {
              this.billRecordData = data.items
              this.billRecordData.forEach(billRecord => {
                let periods = []
                billRecord.periods ? periods = billRecord.periods.split(',') : periods = []
                if (periods.length > 0) {
                  for (let i = 0; i < periods.length; i++) {
                    periods[i] = (periods[i].substr(0, 4) + (parseInt(periods[i].slice(4), 10) < 10 ? '0' : '')) + parseInt(periods[i].slice(4), 10)
                  }
                }
                billRecord.periods = periods.join(',')
              });
            }
          }
        })
      },
      // 预览图片
      previewImg(itemArr, filePath) {
        console.log(filePath)
        let imageArr = []
        itemArr.forEach((i) => {
          if (i.fileFormat.toLocaleLowerCase() === 'jpg' || i.fileFormat.toLocaleLowerCase() === 'png') {
            imageArr.push(i.filePath)
          }
        })
      },
      gotoNewFollowup(isEdit, followup) {
        console.log(followup)
        this.$root.$emit('log-record', "60010110");
        this.$router.push({
          name: 'newFollowup',
          params: followup,
          query: {
            'companyId': this.companyId,
            customerInfo: this.customerInfo,
            'isEdit': isEdit
          }
        })
      },
      gotoNewBill(isEdit, billRecord) {
        if (!this.estimatePower("代账服务", "服务管理", "收票")) {
          Toast("没有权限：服务管理-收票");
          return;
        }
        this.$root.$emit('log-record', "60010111");
        let query = {
          'companyId': this.companyId,
          'isEdit': isEdit
        }
        if (isEdit == 0) {
          query.acquireBatchId = billRecord.acquireBatchId
        }
        this.$router.push({
          name: 'newBill',
          query: query,
        })
      },
      gotoCheckReport() {
        if (!this.estimatePower("代账服务", "服务管理", "进账簿")) {
          Toast("没有权限：服务管理-进账簿");
          return;
        }
        this.$router.push({
          name: 'customerReportHome',
          query: {
            customer: this.$route.query.customer
          }
        })
      },
      formatStatus(status) {
        let statusName = ''
        switch (status) {
          case 1:
            statusName = "进行中";
            break;
          case 2:
            statusName = "已完成";
            break;
          case 3:
            statusName = "未开始";
            break;
          default:
            statusName = ''
        }
        return statusName
      },
      getCompanyInfo() {
        this.$http
          .get("/fc/small/program/staffinfocus")
          .then(res => {
            if (res.data.code == 200) {
              this.getPowerData(res.data.data.staffId)
            }
          })
          .catch(error => {
            console.log(error, "error");
          });
      },
      //获取职员权限
      getPowerData(staffId){
        if(!staffId){
          return
        }
        this.$http
          .get("/fc/small/program/staff/power?staffId=" + staffId)
          .then(res => {
            if (res.data.code == 200) {
              this.$store.dispatch("setPowerData", res.data.data);
              this.powerData = res.data.data
              if(this.estimatePower('客户管理','客户','查看服务信息')){
                this.showFWXX = true
              }
              if(this.estimatePower('代账服务','服务管理','收票记录')){
                this.showSPJL = true
              }
            } 
          })
          .catch(error => {
            console.log(error, "error");
          });
      },
    },
    beforeMount(){
      if(this.$route.query.power == 1){
        this.getCompanyInfo()
      }
    },
    mounted: function () {
      this.$root.$emit('log-record', "60010122");
      this.companyId = this.$route.query.companyId || this.$route.query.customer.companyId || this.$store.state.fromAcctCustomerInfo.companyId;
      if (parseInt(window.sessionStorage.getItem('tabIndex')) > 0) {
        this.tabIndex = parseInt(window.sessionStorage.getItem('tabIndex'))
      } else {
        this.tabIndex = parseInt(this.$route.query.tabIndex)
      }
      window.sessionStorage.removeItem('tabIndex')
      document.title = '客户详情'
      let currentDate = new Date()
      this.year = currentDate.getFullYear()
      this.month = currentDate.getMonth() + 1
      if (!this.date) {
        this.formatDate()
      }
      this.getCustomerInfo()
      if (this.tabIndex === 0) {
        this.getCustomerService()
      } else if (this.tabIndex === 2) {
        // if (!this.estimatePower("代账服务", "服务管理", "收票记录")) {
        //   Toast("没有权限：服务管理-收票记录");
        //   return;
        // }
        this.getBillRecord()
      } else {
        this.getFollowup()
      }
      if(this.$route.query.power != 1){
        if(this.estimatePower('客户管理','客户','查看服务信息')){
          this.showFWXX = true
        }
        // if (this.estimatePower('客户管理','客户','查看跟进记录')) {
        //   this.showFollow = true
        // }
        if(this.estimatePower('代账服务','服务管理','收票记录')){
          this.showSPJL = true
        }
      }
    }
  }
</script>

<style type="text/css" lang="stylus" scoped>
  //  ::-webkit-scrollbar { width: 6px;}
  a {
    color: #333;
  }

  .customer-detail {
    height: 100%;
    background-color: #f5f5f5;
    overflow: hidden;
  }

  .ofauto.customer-detail {
    overflow: auto;
  }

  .top-wrap {
    z-index: 1;
    border-bottom: 1px solid #E6EBF0;
  }

  .customer-infowrap {
    background-color: white;
  }

  .customer-info {
    display: flex;
    flex-direction: row;
    margin: 0 0.2rem;
    padding: 0.12rem 0;
    border-bottom: 1px solid #ddd;
  }

  .customer-info .left {
    width: 50px;
  }

  .left img {
    width: 40px;
    height: 40px;
  }

  .customer-info .middle {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: #999;
  }

  .customername {
    color: #333;
  }

  .customer-info .right {
    width: 90px;
    text-align: right;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .contact-wrap {
    display: flex;
    justify-content: flex-end;
  }

  .contact {
    font-weight: 500;
  }

  .contact-wrap img {
    width: 20px;
  }

  .phone-a {
    padding-left: 0.05rem;
  }

  .renew {
    color: #1fadf6;
  }

  .customer-bottom {
    display: flex;
    justify-content: space-between;
    padding: 0.12rem 0;
    font-size: 0.12rem;
    color: #999;
    margin: 0 0.2rem;
    border-bottom: 1px solid #d8dfe6;
  }

  .saleman {
    min-width: 0.84rem;
    text-align: right;
  }

  .navbar-itemall-wrap {
    /* border-bottom: 1px solid #ddd; */
    background-color: white;
    /* border-top: 1px solid #ddd; */
  }

  .navbar-item {
    display: inline-block;
    width: 49%;
    line-height: 0.4rem;
    text-align: center;
    font-size: 0.16rem;
    cursor: pointer;
  }

  .navbar-active {
    color: #1fadf6;
    border-bottom: 3px solid #1fadf6;
    margin-bottom: -3px;
  }

  .serviceinfo-wrap {
    background-color: #f5f5f5;
    overflow: hidden;
  }

  .dispatch-wrap,
  .service-wrap,
  .order-wrap,
  .taxInfor-wrap {
    margin: 0.12rem 0;
    background-color: white;
  }

  .dispatch-wrap {
    display: flex;
    align-items: center;
    padding: 0.08rem 0;
  }

  .dispatch-item {
    display: flex;
    flex-direction: column;
    flex: 1;
    text-align: center;
    line-height: 0.2rem;
    color: #999;
    /* padding: 0.1rem 0; */
  }

  .vertical-line {
    width: 1px;
    height: 0.36rem;
    background-color: #E6EBF0;
  }

  /**/
  .taxInfor-content {
    color: #333;
  }

  .taxInfor-row {
    display: flex;
    align-items: center;
    padding: 10px 0px;
    align-items: flex-start;
  }

  .item-title {
    color: #8896A4;
    font-size: 0.12rem;
  }

  .item-content {
    word-break: break-all;
    color: #2C3E50;
  }

  .taxInfor-row .taxInfor-item:first-child {
    padding-right: 10px;
    box-sizing: border-box;
  }

  .taxInfor-item {
    display: flex;
    flex-direction: column;
    flex: 1;
    text-align: left;
    line-height: 30px;
    color: #999;
    overflow: hidden;
  }

  .taxKind {
    border-top: 1px solid #ddd;
    padding: 12px 0 0 0;
    margin-bottom: 0.5rem;
  }

  .taxKind ul {
    margin-bottom: 0;
  }

  .remark1 {
    margin-bottom: 12px;
    word-break: break-all;
  }

  .service-wrap,
  .order-wrap,
  .taxInfor-wrap {
    padding: 12px 0px 0px;
  }

  .service-title,
  .order-title,
  .taxInfor-title {
    line-height: 20px;
    padding-left: 12px;
    font-size: 16px;
  }

  .service-acct,
  .service-business {
    color: #999;
    border-bottom: 1px solid #ddd;
    /*padding: 12px 4px 12px 0px;*/
  }

  .servicename {
    color: #333;
  }

  .acct-top,
  .business-top {
    display: flex;
    justify-content: space-between;
  }

  .acct-ul,
  .taxKind-ul {
    margin: 8px 0;
    line-height: 28px;
  }

  .acct-time,
  .bus-time {
    position: relative;
    float: right;
  }

  .taxKind-li span.taxKind-first {
    display: inline-block;
    width: 70%;
    padding-right: 20px;
    box-sizing: border-box;
    color: #516374;
  }

  .taxKind-li span.taxKind-last {
    display: inline-block;
    width: 30%;
    text-align: right;
    color: #8896A4;
  }

  .li-disc {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 6px;
    margin-right: 8px;
    background-color: #1fadf6;
  }

  .acct-ul li:nth-child(2n) .li-disc {
    background-color: #ff9933;
  }

  .service-business {
    border-bottom: 0px;
  }

  .business-top {
    color: #333;
  }

  .business-item {
    line-height: 20px;
    margin-bottom: 12px;
    border-bottom: 1px solid #ddd;
  }

  .business-item:last-child {
    border-bottom: 0px;
    margin-bottom: 0px;
  }

  .busnode {
    line-height: 40px;
  }

  .service-wrap {
    margin-bottom: 12px;
  }

  .order-content,
  .service-content,
  .taxInfor-content {
    padding: 12px;
    color: #999;
  }

  .taxInfor-content {
    color: #333;
  }

  .service-content>div {
    margin-bottom: 12px;
  }

  .service-content>div:last-child {
    border-bottom: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .order-content>div {
    display: flex;
    justify-content: space-between;
    line-height: 24px;
  }

  div.orderno-wrap {
    color: #999;
    font-size: 12px;
    line-height: 24px;
    margin-bottom: 8px;
  }

  .vieworder {
    color: #999;
    margin-top: 8px;
  }

  .followup-wrap {
    background-color: white;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    height: 3.94rem;
    margin-top: 0.08rem;
    border-top: 0.01rem solid #E6EBF0;

    .followup-msg {
      height: 0.4rem;
      padding: 0.1rem 0;
      // border-bottom: 1px solid #e6ebf0;
    }

    .msg {
      line-height: 0.2rem;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
  }

  .add-btnwrap {
    text-align: center;
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 2;
    font-weight: bold;
  }

  .add-btnwrap.disabled span {
    background-color: #f7f7f7;
    color: #8896A4;
  }

  .add_btnwrap_router {
    display: inline-block;
    text-align: center;
    width: 3.44rem;
    line-height: 40px;
    background-color: #FFFFFF;
    color: #1FADF6;
    border-radius: 20px;
  }

  .add-btnwrap span {
    display: inline-block;
    text-align: center;
    width: 100%;
    line-height: 0.5rem;
    background-color: #FFFFFF;
    color: #1FADF6;
    border-top: 1px solid #E6EBF0;
  }
</style>

<style scoped>
  .el-step__head.is-text.is-process {
    background-color: white;
    border-color: #51b1fc;
  }

  .el-step__title.is-process {
    font-size: 13px;
    color: #333;
    font-weight: normal;
  }

  .step-followup.el-step {
    display: flex;
    padding-bottom: 12px;
    font-size: 13px;
  }

  .step-followup.el-step:last-child {
    padding-bottom: 0px;
  }

  .step-followup .el-step__head {
    width: 16px;
    height: 16px;
  }

  .step-followup .el-step__head,
  .step-followup .el-step__head .el-step__icon {
    line-height: 22px;
  }

  .step-followup.el-step.is-vertical .el-step__main {
    line-height: 24px;
    flex: 1;
    padding-right: 0px;
    overflow: hidden;
  }

  .step-followup .el-step__line.is-vertical {
    width: 1px;
    top: 15px;
    left: auto;
    color: #ccc;
  }

  .step-followup .el-step__text {
    display: flex;
    justify-content: space-between;
  }

  .step-followup .el-step__text .el-step__title {
    flex: 1;
    margin: 0px;
    width: 100px;
    line-height: 24px;
  }

  .followup-wrap i.el-step__icon {
    width: 16px;
    height: 16px;
    position: relative;
  }

  .el-icon-yellow {
    background: url('../../../assets/customer/followup_yellow.png') no-repeat left center;
  }

  .el-icon-gray {
    background: url('../../../assets/customer/followup_gray.png') no-repeat left center;
  }

  .step-followup .el-step__staffname {
    display: inline-block;
    font-size: 13px;
    width: 80px;
    text-align: right;
  }

  .el-step__time {
    color: #999;
  }

  .el-step__filewrap {
    display: flex;
    padding: 8px 0px;
  }

  .el-step__filewrap span {
    display: inline-block;
    width: 40px;
    height: 40px;
    margin-right: 12px;
  }

  .el-step__filewrap img {
    width: 100%;
    height: 100%;
    border: 1px solid #eee;
  }

  .el-step__filewrap span.non-img {
    width: auto;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 100%;
    overflow: hidden;
    display: inline-block;
  }
</style>
<style lang="stylus">
  .customer-detail {
    .balTab {
      // border-top:1px solid #D8DFE6;
      padding: .11rem 0;
    }

    .balTab .van-tabs .van-tabs__wrap .van-tabs__nav {
      border-radius: 100px;
    }

    .balTab .van-tabs .van-tabs__wrap .van-tabs__nav>.van-tab:first-child {
      border-radius: 100px 0 0 100px;
    }

    .balTab .van-tabs .van-tabs__wrap .van-tabs__nav>.van-tab:last-child {
      border-radius: 0 100px 100px 0;
    }

    // 步骤
    [class*=van-hairline]::after {
      position: absolute;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      top: -50%;
      right: -50%;
      bottom: -50%;
      left: -50%;
      border: 0;
      -webkit-transform: scale(.5);
      transform: scale(.5);
    }

    .van-steps--vertical {
      padding: 12px 0 0 35px;
    }

    .van-step__circle {
      width: 0.07rem;
      height: 0.07rem;
    }

    .van-step__line {
      background-color: #dfe5e8;
    }

    .van-hairline {
      margin-right: 0.17rem;
      padding: 10px 0;
      border-bottom: 1px solid #e6ebf0;
    }

    .empty {
      text-align: center;
      padding-top: 1.4rem;

      img {
        width: 0.8rem;
      }

      .desc {
        margin-top: 0.08rem;
        color: #B4BEC7;
        font-size: 0.12rem;
      }
    }
  }
</style>